"use client";

import AnalyticsSessionInit from "@/components/layout/AnalyticsSessionInit";
import CookieConsent from "@/components/layout/CookieConsent";
import GlobalErrorHandler from "@/components/layout/GlobalErrorHandler";
import GoogleAnalytics from "@/components/layout/GoogleAnalytics";

interface GlobalClientUtilitiesProps {
  gaId: string;
}

export function GlobalClientUtilities({ gaId }: GlobalClientUtilitiesProps) {
  return (
    <>
      <GlobalErrorHandler />
      <AnalyticsSessionInit />
      <GoogleAnalytics gaId={gaId} />
      <CookieConsent />
    </>
  );
}
